import axios from 'axios';
import bdApi from '../Api/BankDataApi';
import Notifications from 'react-notification-system-redux';
import * as constants from './types';

const tokenError = (status, dispatch) => {
  if (status === 401) return dispatch({ type: constants.REQUEST_FAILURE, payload: "Your token is invalid / expired, please try again." });
}

const shapeBankFeeds = bankfeeds => (
  bankfeeds.reduce((filtered, bankfeed) => { 
      if (bankfeed.isProductLinked === 0 && bankfeed.isDeleted === 0 && bankfeed.isLinked !== 0) {
        const isYodlee = !!bankfeed.YodleeItemID;
        const bankName = `${bankfeed.BankName}${isYodlee ? ' (Yodlee)' : ''}`
        const bankfeedId = `${isYodlee ? bankfeed.YodleeItemID : bankfeed.BSB}${bankfeed.AccountNumber}`;
        const accountNumber = `${isYodlee ? '' : bankfeed.BSB} ${bankfeed.AccountNumber}`;
        bankfeed = {
            bankName,
            bankfeedId,
            accountNumber,
            feedId: bankfeed.FeedID,
            clientAccountId: bankfeed.ClientAccountID,
            yodleeItemAccountId: bankfeed.YodleeItemAccountID,
        }
        filtered.push(bankfeed)
      }
      return filtered;
   }, [])
);

export const getBankFeeds = () => {
  return (dispatch) => {
    bdApi.get(`${constants.ROOT_URL}/bankfeed/`)
    .then(response => {
      const bankfeeds = shapeBankFeeds(response.data.feeds);
      dispatch({ type: constants.GET_BANKFEEDS, payload: bankfeeds });
      dispatch({ type: constants.BANKFEEDS_LOAD_COMPLETED, payload: true })
    })
    .catch(error => {
      dispatch({ type: constants.BANKFEEDS_SET_API_ERROR, payload: true });
      if (!error.response) return dispatch({ type: constants.NO_ERROR_RESPONSE, payload: "Unable to process the request." });
      tokenError(error.response.status, dispatch);
    });
  }
}

export function clearBankfeeds() {
  return { type: constants.CLEAR_BANKFEEDS };
}

export function getBankFeedList() {
    return function(dispatch) {
        bdApi.get(`${constants.ROOT_URL}/bankfeed/bankfeedlist/`)
        .then(response => {
          const bankfeedlist = response.data.map(bankfeed => {
              if(bankfeed.bankId === 7) bankfeed.yodleeFeedId = 105348; /// nab au
              if(bankfeed.bankId === 29) bankfeed.yodleeFeedId = 112292; // bank of queensland au
              if(bankfeed.bankId === 18) bankfeed.yodleeFeedId = 117118; // bank of melbourne au
              if(bankfeed.bankId === 21) bankfeed.yodleeFeedId = 112308; // bank of sa au
              if(bankfeed.bankId === 4) bankfeed.yodleeFeedId = 103857; // commbank au
              if(bankfeed.bankId === 2) bankfeed.yodleeFeedId = 112099; // st george au
              if(bankfeed.bankId === 17) bankfeed.yodleeFeedId = 103885; // westpac au

              if(bankfeed.bankId === 28) bankfeed.yodleeFeedId = 112287; // anz nz
              if(bankfeed.bankId === 16) bankfeed.yodleeFeedId = 104330; // asb nz
              if(bankfeed.bankId === 33) bankfeed.yodleeFeedId = 112246; // tsb nz
              if(bankfeed.bankId === 26) bankfeed.yodleeFeedId = 112252; // westpac nz
              return bankfeed;
            })
          dispatch({ type: constants.GET_BANKFEED_OPTIONS, payload: bankfeedlist});
        })
        .catch((error) => {
          if (!error.response) return dispatch({ type: constants.NO_ERROR_RESPONSE, payload: "Unable to process the request." });
          tokenError(error.response.status, dispatch);
        });
    };
}

export function getBankFeedShares() {
    const bookId = localStorage.getItem('bookid');

    return function(dispatch) {
        dispatch({ type: constants.REQUEST_BANKFEED_SHARES });

        bdApi.get(`${constants.ROOT_URL}/books/${bookId}/shares`)
        .then(response => {
          dispatch({ type: constants.GET_BANKFEED_SHARES, payload: response.data});
        })
        .catch((error) => {
          if (!error.response) return dispatch({ type: constants.NO_ERROR_RESPONSE, payload: "Unable to process the request." });
          tokenError(error.response.status, dispatch);
        });
    };
}

export function addBankFeedShare(shareData) {
    const bookId = localStorage.getItem('bookid');

    return function(dispatch) {
        dispatch({ type: constants.REQUEST_ADD_BANKFEED_SHARE });
        bdApi.post(`${constants.ROOT_URL}/books/${bookId}/share`, shareData)
        .then(response => {
          if (response.data.result === 'success') {
            dispatch({ type: constants.ADD_BANKFEED_SHARE });
            bdApi.get(`${constants.ROOT_URL}/books/${bookId}/shares`)
            .then(response => {
              dispatch({ type: constants.GET_BANKFEED_SHARES, payload: response.data});
            });
          } else {
            dispatch({ type: constants.ADD_BANKFEED_SHARE_FAILURE, error: 'Shared Access already exists for this User' });
          }
        })
        .catch((error) => {
          if (!error.response) return dispatch({ type: constants.NO_ERROR_RESPONSE, payload: "Unable to process the request." });
          if (error.response.status === 400) dispatch({ type: constants.ADD_BANKFEED_SHARE_FAILURE, error: error.response.data.message });
          else dispatch({ type: constants.ADD_BANKFEED_SHARE_FAILURE, error: 'Error occured, please try again.' });
          tokenError(error.response.status, dispatch);
        });
    };
}

export function deleteBankFeedShare(emailAddress) {
    const bookId = localStorage.getItem('bookid');

    return function(dispatch) {
        dispatch({ type: constants.REQUEST_DELETE_BANKFEED_SHARE });
        bdApi.delete(`${constants.ROOT_URL}/books/${bookId}/share/${emailAddress}`)
        .then(response => {
          if (response.data.result === 'success') {
            dispatch({ type: constants.DELETE_BANKFEED_SHARE });
            bdApi.get(`${constants.ROOT_URL}/books/${bookId}/shares`)
            .then(response => {
              dispatch({ type: constants.GET_BANKFEED_SHARES, payload: response.data });
            });
          } else {
              dispatch({ type: constants.DELETE_BANKFEED_SHARE_FAILURE });
          }
        })
        .catch((error) => {
          if (!error.response) return dispatch({ type: constants.NO_ERROR_RESPONSE, payload: "Unable to process the request." });
          dispatch({ type: constants.DELETE_BANKFEED_SHARE_FAILURE });
          tokenError(error.response.status, dispatch);
        });
    };
}

export function sendEmail(email, message) {
  const bookid = localStorage.getItem('bookid');
  const emailMessage = message.replace(/\n/g, '<BR>').concat('<BR><BR>');

  return function(dispatch) {
    dispatch({ type: constants.REQUEST_SEND_EMAIL });
    bdApi.post(`books/${bookid}/sendemail`, { username: email, customMessage: emailMessage })
    .then(() => {
      dispatch({ type: constants.SEND_EMAIL });
    })
    .catch((error) => {
      if (!error.response) return dispatch({ type: constants.NO_ERROR_RESPONSE, payload: "Unable to process the request." });
      dispatch({ type: constants.SEND_EMAIL_FAILURE, payload: "Attempt failed, please try again." });
      tokenError(error.response.status, dispatch);
    });
  };
}

export function clearShareState() {
   return { type: constants.CLEAR_SHARE_STATE };
}

export function login(username, password) {
    const userData = { username, password };

    return function(dispatch) {
      dispatch({ type: constants.REQUEST_LOGIN });
      axios.post(`${constants.ROOT_URL}/auth/login/`, userData)
        .then(response => {
          localStorage.setItem('token', response.data.token);
          dispatch({ type: constants.LOGIN_SUCCESS, payload: response.data});
        })
        .catch((error) => {
          dispatch({ type: constants.LOGIN_FAILURE, payload: error});
        });
    };
}

export function logout() {
  localStorage.removeItem('token');
  return { type: constants.LOGOUT };
}

export function validateToken() {
  return function(dispatch) {
    bdApi.get(`${constants.PORTAL_URL}/auth/tokenvalidate/`)
      .then(response => {
        dispatch({ type: constants.LOGIN_SUCCESS, payload: response.data });
      })
      .catch((error) => {
        localStorage.removeItem('token');
        dispatch({ type: constants.REQUEST_FAILURE });
      });
  };
}

export function validatePasswordToken (params) {
  const { username, passwordResetToken } = params;
  const userData = { username, passwordResetToken };

  return function(dispatch) { 
    axios.post(`${constants.ROOT_URL}/auth/validateresettoken`, userData)
    .catch((error) => {
      dispatch({ type: constants.REQUEST_FAILURE, payload: "You have already set up a password for this username." });
    });
  }
}

export function setPassword(params, password) {
  const { username, passwordResetToken } = params;
  const userData = { username, password, passwordResetToken };
  
  return function(dispatch) {
    dispatch({ type: constants.REQUEST_SET_PASSWORD });

    axios.post(`${constants.ROOT_URL}/auth/setpassword/`, userData)
      .then((response) => {
        dispatch({ type: constants.SET_PASSWORD_SUCCESS });
        }
      )
      .catch((error) => {
        dispatch({ type: constants.SET_PASSWORD_FAILURE });
        }
      )
  }
}

export function resetPassword(username) {

  return function(dispatch) {
      dispatch({ type: constants.REQUEST_RESET_PASSWORD });
      new Promise((resolve, reject) => {
        setTimeout(() => {
          reject();
        }, 500)
      })
      .then(response => {
        dispatch({ type: constants.RESET_PASSWORD_SUCCESS });
      })
      .catch((error) => {
        dispatch({ type: constants.RESET_PASSWORD_FAILURE, error});
      });
  };
}

export function getBnzAccountList(token) {
  return function(dispatch) {
    bdApi.get(`/bankfeed/bnz/accounts/${token}`)
      .then(response => {
        dispatch({ type: constants.GET_BANKFEEDS, payload: response.data.accounts });
      })
      .catch((error) => {
        dispatch({ type: constants.SET_ERROR });
      });
  };
}

export function addBnzFeeds (data, creating, goToBFM) {
  return function(dispatch) {
    if (data.accounts.length) {
      creating(true);
      bdApi.post('/bnz/createfeeds', data)
      .then(() => {
        dispatch({ type: constants.NO_ACTION });
        goToBFM();
      })
      .catch((error) => {
        creating(false);
        dispatch({ type: constants.SET_ERROR });
      });
    } else {
      dispatch(Notifications.warning({ message: 'You have not selected any accounts' }));
    }
  };
}

export function getSissURL() {
  return function(dispatch) {
    bdApi.get(`/siss/consent/${localStorage.getItem("bookid")}`)
      .then(response => {
        dispatch({ type: constants.GET_SISS_URL, payload: response.data.body.redirectUri });
      })
      .catch((error) => {
        dispatch({ type: constants.SET_ERROR });
      });
  };
}

export function clearSissURL() {
  return { type: constants.GET_SISS_URL, payload: undefined };
}


// WEBPACK FOOTER //
// ./src/Actions/bankfeeds.js